import React, { useContext, useEffect, useRef, useState } from "react";
import { getData } from "../services/API";
import ThemeOne from "../components/ResumeThemes/ThemeOne";
import ThemeTwo from "../components/ResumeThemes/ThemeTwo";
import ThemeThree from "../components/ResumeThemes/ThemeThree";
import ThemeFour from "../components/ResumeThemes/ThemeFour";
import { useReactToPrint } from "react-to-print";
import { UserData } from "../contexts/UserInfoContext";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { Link, useParams } from "react-router-dom";
import avatar from "../images/avatar.png";
import { toFarsiNumber } from "../helper/helper";

const FacultyLicense = () => {
  const { user, userLoaded } = useContext(UserData);
  const [loading, setLoading] = useState(true);
  const [once, setOnce] = useState(true);
  const [resume, setResume] = useState({});
  const printCom = useRef();

  const param = useParams();

  useEffect(() => {
    const element = document.querySelector('meta[name="viewport"]');
    element.setAttribute("content", "width=1024");

    if (once) {
      setOnce(false);
      getData(`/faculty-list-id/${param.id}`).then((res) => {
        setLoading(false);
        setResume(res.data);
      });
    }
  }, [userLoaded]);

  const handlePrint = useReactToPrint({
    content: () => printCom.current,
  });

  return (
    <div className="w-full min-h-screen h-auto flex flex-col gap-5 py-10 items-center bg-white overflow-x-hidden">
      {loading ? (
        <span className="text-2xl font-black">لطفا صبر کنید...</span>
      ) : (
        <>
          <div className="flex flex-col gap-4">
            <span className="text-2xl font-black">مدارک کاربر {resume.name + " " + resume.family_name}</span>

            <div className="flex flex-col gap-2">
              <span>فایل ها :</span>

              <div className="flex gap-2 text-blue-600">
                {resume.docs?.length > 0 ? resume.docs.map(doc => doc.slice(-3) === "pdf" && <Link download target="_blank" to={`https://api.myunibest.ir/${doc}`}>فایل pdf</Link>) : ""}
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <span>تصاویر :</span>

              {resume.docs?.length > 0 ? resume.docs.map(doc => doc.slice(-3) === "png" || doc.slice(-3) === "jpg" && <img className="w-[500px]" src={`https://api.myunibest.ir/${doc}`} alt="" />) : ""}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default FacultyLicense;
